import gql from "graphql-tag";

export const CREATE_INVOICE = gql`
  mutation createInvoice($input: invoiceInput) {
    createInvoice(input: $input) {
      _id
      code
      name
      period
      payment_due
      total_due
      sub_total
      currency
      sent_to
      sent_at
      issue_date
      items {
        description
        hours
        cost
      }
    }
  }
`;
